module.exports = __webpack_public_path__ + "img/weddings_29_H.f3737e64.webp";